import { connect } from 'react-redux';
import {
  deleteLabCategory,
  createLabCategory,
  updateLabCategorySubcategories,
} from 'shared/store/actions/lab.categories.actions';
import { getLabCategoryById } from 'shared/store/selectors/lab.selector';
import { LabSectionListComponent } from './lab-section-list.component';
import { labSelectValues } from 'src/store/actions/labViewer.actions';

const mapStateToProps = ({ application, lab, lang }, { id }) => ({
  adminMode: application.adminMode,
  category: getLabCategoryById(lab, { id }),
  lang: lang.CONTENT_LIST,
});

const mapDispatchToProps = {
  deleteCategory: deleteLabCategory,
  createCategory: createLabCategory,
  updateCategorySubcategories: updateLabCategorySubcategories,
  labSelectValues,
};

export const LabSectionList = connect(mapStateToProps, mapDispatchToProps)(LabSectionListComponent);
